/** @module Specification/CareAndComposition/CareTab */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/storage",
	"csi/action/Switchboard",
	"csi/def/Toolbar",
	"csi/html/Widget",
	"csi/xml",
	"csi/xml/Query",
	"./CareAndCompositionProductSalesRegionSwitchboard"
], function(declare,lang,storage,SwitchboardAction,Toolbar,Widget,xml,Query,CareAndCompositionProductSalesRegionSwitchboard) {

	var STORAGE_KEY = "ProductSalesRegionURL";

	return declare(Widget, {
		plugins: [],
		
		/**
		 * ProductSalesRegion selector on the CareAndComposition (Editing) tab
		 */
		_resolveView: function() {
			this.defView.defToolbar = lang.mixin(new Toolbar(), {
				m_actions: [
					lang.mixin(new SwitchboardAction(), {
						classToolbarPlugin: CareAndCompositionProductSalesRegionSwitchboard,
						m_id: "SelectProductSalesRegion",
						m_fixedQuery: new Query().Attr("Active", xml.OP_EQUALS, true),
						m_postAction: "postActionRefresh"  // enable/disable children view matrices when SalesRegion is selected/de-selected
					})
				]
			});

			this.inherited(arguments);
		},

		/**
		 * Set the store per selected SalesRegion
		 */
		onViewCreate : function() {
			this.set("activeProductSalesRegion", storage.get(STORAGE_KEY));

			this.watch("activeProductSalesRegion", function(name, oldValue, newValue) {
				storage.set(STORAGE_KEY, newValue);
			});

			this.inherited(arguments);
		}

	});
});